import React from 'react';
import {RestoreScreen} from './Edit';

export const Copy: React.FC = React.memo(() => {
  return <RestoreScreen editMode="copy" />;
});
